import FontIcon from './component'
export { FontIcon }
export default FontIcon